<div class="d-inline-flex" [attr.title]="disabledMessage | messageTranslate">
  <button class="btn"
          [ngClass]="buttonStyles"
          [disabled]="disabled"
          (click)="recalculate()">
    <fa-icon icon="calculator"
             [title]="!showText ? ('Recalculate Meter Data' | messageTranslate) : undefined"
             [appShowFaSpinner]="recalculating"/>
    @if (showText) {
      <span>{{ 'Recalculate Meter Data' | messageTranslate }}</span>
    }
  </button>
</div>


<ng-template #recalculateRangePicker let-modal>
  <form [formGroup]="refreshRangeForm" (ngSubmit)="submitRecalculation()">
    <div class="modal-header">
      <h5 class="modal-title">{{ 'Meter Data Recalculation Period' | messageTranslate }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="asModal(modal).dismiss()"></button>
    </div>
    <div class="modal-body">
      @if (meterDataRange) {
        <div>
          <small class="text-danger">{{ 'Meter stream has data' | messageTranslate:{start: meterDataRangeStart, end: meterDataRangeEnd} }}</small>
        </div>
      }
      <div class="mt-1">
        {{ 'Select Range' | messageTranslate }}
      </div>
      <div class="mt-1">
        <label class="form-label">
          <input type="radio" name="rangeType" [formControlName]="RANGE_TYPE" [value]="RangeType.WHOLE_PERIOD"/> {{ 'Whole Period' | messageTranslate }}
          <div>
            <small class="text-body-secondary">
              {{ 'From start to end' | messageTranslate:{start: recalculationRangeStart, end: recalculationRangeEnd} }}
            </small>
          </div>
        </label>
      </div>
      <div class="mt-1">
        <label class="form-label">
          <input type="radio" name="rangeType" [formControlName]="RANGE_TYPE" [value]="RangeType.SPECIFY_PERIOD"/> {{ 'Specify Period' | messageTranslate }}
        </label>
        @if (refreshRangeForm.get(RANGE_TYPE).value === RangeType.SPECIFY_PERIOD) {
          <div class="mt-1">
            <app-date-time-range-select [formControlName]="RANGE"
                                        [showTime]="showTimePicker"
                                        [minDate]="recalculationRange.start_ts"
                                        [maxDate]="recalculationRange.end_ts"/>
          </div>
        }
      </div>
    </div>
    <div class="modal-footer">
      <app-button type="submit" visual="primary" label="Submit" [loading]="submitting" [disabled]="!refreshRangeForm.valid"/>
      <app-button visual="secondary" label="Cancel" [disabled]="submitting" (buttonClick)="asModal(modal).dismiss()"/>
    </div>
  </form>
</ng-template>
